
<script>
import Vue from "vue";
import config from "../../libs/config.js";

import moment from "moment";
import func from "../../libs/functions.js";
import { EventBus } from "../../libs/event-bus.js";
import api from "../../api";
import _system from "../../libs/system";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import StatisticsFilter from "./StatisticsFilter.vue";
import PieChart from "./PieChart.vue";
import statistics from "../../libs/system/services/statistics";
import html2pdf from "html2pdf.js";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import { Datetime } from "vue-datetime";
Vue.component("datetime", Datetime);
import "vue-datetime/dist/vue-datetime.css";

import { getPlatformImage } from "./mixins/getPlatformImage";

export default {
  name: "statistics",
  mixins: [getPlatformImage],
  components: {
    StatisticsFilter,
    PieChart,
    DateRangePicker,
  },
  data() {
    return {
      lineChartConfig: [],
      customColorPalette: [
          '#e6194b', '#3cb44b', '#ffe119', '#0082c8', '#f58231',
          '#911eb4', '#46f0f0', '#f032e6', '#d2f53c', '#fabebe',
          '#008080', '#e6beff', '#aa6e28', '#fffac8', '#800000',
          '#aaffc3', '#808000', '#ffd8b1', '#000080', '#808080',
          '#000000'
      ],
      picker: {
        minDate: "",
        minSelectedDate: "",
        maxDate: "",
        maxSelectedDate: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
      },
      func: func,
      moment: moment,
      loading: false,
      pages: [],
      tags: [],
      stats: {
        messagesCountObject: [],
        conversationCount: 0,
        getCountByPagesAndPlatforms: [],
        getAudincesByPages: [],
        messagesCount: "0",
        tags: [],
        averageResponseTime: {
          averageFirstReplyTime: 0,
          repliedConversationCount: 0,
        },
      },
      audience: [],
      teamStatistics: [],
      charts: {
        lineChart: {},
      },
      show: {
        pieChart: false,
      },
      totalRepliedMesages: 0,
      startDate: "",
      endDate: "",
      currentDate: "",
    };
  },
  computed: {
    ...mapGetters("loading", ["loadingStatistics"]),
    ...mapGetters("session", ["isLoggedIn", "getUser", "getJwt"]),
    ...mapGetters("messages", ["messages"]),
    ...mapGetters("tags", ["tagsById", "getEnumaratedTags", "tagsByName"]),
    ...mapGetters("accounts", ["accounts", "accountsById"]),
    ...mapGetters("networks", ["networksById", "networksByName"]),
    ...mapGetters("statuses", ["statuses"]),
    ...mapGetters("statistics", ["getStatistics"]),
    ...mapGetters("notifications", ["getNotificationMessages"]),
    ...mapGetters("workspaces", ["currentWorkspace"]),
    ...mapGetters("workspaceusers", ["workspaceusers"]),
    ...mapGetters("inboxFilters", [
      "getInboxFilters",
      "getInboxFilterLastUpdatedTime",
    ]),
    isAccountsPlatformShopifExists() {
      return _.find(this.accounts, (account) => {
        return account.platform == this.networksByName["Shopify"]._id;
      });
    },
    onlyActiveAccounts() {
      let onlyActivePages = _.filter(this.accounts, (item) => {
        if (
          (item.tags &&
            item.tags.indexOf(this.tagsByName["Passive"]._id) == -1) ||
          !item.tags
        )
          return item;
      });

      onlyActivePages = _.map(onlyActivePages, (item) => {
        //custom by user email
        if (this.getUser.email.includes("upchannels.com")) {
          item.name = item.name.substring(0, 29);
        } else {
          item.name = item.name.substring(0, 19);
        }

        return item;
      });

      return onlyActivePages;
    },
  },
  methods: {
    ...mapActions("messages", ["setMessages"]),
    ...mapActions("statuses", ["setStatuses"]),
    ...mapActions("statistics", ["setStatistics"]),
    ...mapActions("inboxFilters", [
      "setInboxFilters",
      "setInboxFiltersPageIds",
      "setInboxFiltersIsMention",
      "setInboxFiltersTags",
      "setInboxFiltersNotTags",
      "setInboxFiltersStatusId",
      "setInboxFiltersSkip",
      "setInboxFiltersType",
      "setInboxFiltersAfter",
      "setInboxFiltersBefore",
      "setInboxFiltersAssignedToMe",
      "setInboxFilterLastUpdatedTime",
      "setSaveFilters",
    ]),
    ...mapActions("loading", ["setLoadingStatistics"]),
    ratingDistribution(tags) {
      let mappedTags = _.filter(tags, (tag) => {
        if (tag.name && tag.name.length) {
          return tag.name.includes("Star") === true;
        }
      });

      const sum = mappedTags.reduce((total, obj) => total + obj.total, 0);

      let percentagesIncluded = mappedTags.map((tag) => {
        tag.percentage = ((tag.total / sum) * 100).toFixed(2);

        return tag;
      });

      percentagesIncluded = _.map(percentagesIncluded, (tag) => {
        if (tag.name.includes("Five")) {
          tag.color = "#69b34c;";
          tag.sort = 5;
          tag.radius = "0rem 0.5rem 0.5rem 0rem;";
        }
        if (tag.name.includes("Four")) {
          tag.color = "#acb334;";
          tag.sort = 4;
          tag.radius = "0 0 0 0;";
        }
        if (tag.name.includes("Three")) {
          tag.color = "#fab733;";
          tag.sort = 3;
          tag.radius = "0 0 0 0;";
        }
        if (tag.name.includes("Two")) {
          tag.color = "#ff8e15;";
          tag.sort = 2;
          tag.radius = "0 0 0 0;";
        }
        if (tag.name.includes("One")) {
          tag.color = "#ff4e11;";
          tag.sort = 1;
          tag.radius = "0.5rem 0 0 0.5rem;";
        }
        return tag;
      });

      percentagesIncluded = _.orderBy(mappedTags, "sort", "asc");

      return percentagesIncluded;
    },
    orderByName(accounts) {
      return _.orderBy(accounts, ["name"], ["desc"]);
    },
    isActive(_id, type) {
      if (type == "Channels") {
        if (_.find(this.getInboxFilters.pageIds, (id) => id == _id)) {
          return true;
        } else {
          return false;
        }
      }

      if (type == "Dates") {
        if (
          parseInt(
            (+new Date() - this.getInboxFilters.after) / (24 * 60 * 60 * 1000)
          ) == _id
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkActive(item, array) {
      if (array.indexOf(item._id) > -1) {
        return true;
      } else {
        return false;
      }
    },

    updateTime(event) {
      setTimeout(() => {
        this.setInboxFiltersAfter(new Date(this.startDate).getTime());
        this.setInboxFiltersBefore(new Date(this.endDate).getTime());
        this.setInboxFilterLastUpdatedTime(+new Date());
        this.fetchData();
      }, 500);
    },
    updateTime2() {
      let startDate = this.picker.dateRange.startDate.valueOf();
      let endDate = this.picker.dateRange.endDate.valueOf();
      this.lineChartConfig = []

      startDate = startDate - 1000 * 60 * 60 * 12 * 1;
      endDate = endDate - 1000 * 60 * 60 * 12 * 1;

      if (startDate === endDate) {
        endDate = startDate + 1000 * 60 * 60 * 24 * 1;
      }

   /*    console.log(startDate);
      console.log(endDate); */

      /*         console.log(startDate);
        console.log(endDate);
        console.log(endDate - startDate); */
      if (
        this.getUser.email.includes("humanforest") ||
        this.getUser.email.includes("alara")
      ) {
      } else {
        if (
          endDate - startDate > 1000 * 60 * 60 * 24 * 91 ||
          startDate - endDate > 1000 * 60 * 60 * 24 * 91
        ) {
          return alert(
            "Please do not select more than a 3 Month date range at a time."
          );
        }
      }

      this.setInboxFiltersAfter(startDate);
      this.setInboxFiltersBefore(endDate);
      this.setInboxFilterLastUpdatedTime(+new Date());
      this.fetchData();
    },
    updateAccounts(account) {
      this.setInboxFiltersType("page");

      var index = this.getInboxFilters.pageIds.indexOf(account._id);

      if (index > -1) {
        this.getInboxFilters.pageIds.splice(index, 1);
      } else {
        this.getInboxFilters.pageIds.push(account._id);
      }

      this.setInboxFiltersPageIds(this.getInboxFilters.pageIds);
      this.setInboxFilterLastUpdatedTime(+new Date());
    },
    applyFilter(account) {
      this.fetchData();
    },
    fetchData() {
      //this.getConversationCount();
      /*             if(!window.location.href.includes('test=getCountByPages')){
        console.log('LOADED: Message Count')
        this.getMessageCounts();
      }

      this.getTagsWithCounts();
      this.getAverageResponseTime();
      //this.getCountByPagesAndPlatforms();
      this.getAudincesByPages();
      this.renderTeamStatistics();
      this.getDmCmntAds(); */

      //this.getConversationCount();
      this.getTagsWithCounts();
      this.getDmCmntAds();
      this.getAverageResponseTime();
      //this.getCountByPagesAndPlatforms();
      this.getAudincesByPages();

      //this.getConversationCount();
      //this.getConversationCount();

      if (!window.location.href.includes("test=getCountByPages")) {
        console.log("LOADED: Message Count");
        this.getMessageCounts();
      }

      this.renderTeamStatistics();

      setTimeout(() => {
        this.setLoadingStatistics(false);

        /* 
                  this.renderTagsByChannels();
                  this.renderTeamStatistics();
                  this.renderByPlatforms();
                  this.renderAudience(); */
      }, 1000);
    },
    summ(pageId, tagId) {
      return _.chain(messageTags)
        .filter(
          (tag) =>
            tag.pageId == "5c72e8759d65e69f3ebd9077" &&
            tag._id == "5d9b2fa3dc7fa06db0cf7847"
        )
        .map("count")
        .sum()
        .value();
    },
    dateSelected(event) {
      this.picker.minSelectedDate = event.valueOf();
    },
    dateSelected2(event) {
      this.picker.maxSelectedDate = event.valueOf();
    },
    getMessageCounts() {
      this.loading = true;
      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
        },
      };
      if (this.getInboxFilters.after)
        payload.query.after = this.getInboxFilters.after;
      if (this.getInboxFilters.before)
        payload.query.before = this.getInboxFilters.before;
      if (this.getInboxFilters.pageIds)
        payload.query.pageId = this.getInboxFilters.pageIds;

      /*       this.loading = false;
      return; */

      let optimize =
        this.getInboxFilters.before - this.getInboxFilters.after >=
        100 * 60 * 60 * 24 * 14
          ? true
          : false;

      if (optimize) {
        var nextAfter = Math.floor(
          this.getInboxFilters.before -
            (this.getInboxFilters.before - this.getInboxFilters.after) / 2
        );
        var nextBefore = payload.query.before;

        payload.query.before = nextAfter;
        console.log("Yes,Dates Optimized");
      }

      _system.services.statistics.getConversationCountByPage(
        payload,
        (err, data) => {
          if (err) return console.log(err.message);

          if (optimize) {
            payload.query.after = nextAfter;
            payload.query.before = nextBefore;
            _system.services.statistics.getConversationCountByPage(
              payload,
              (err, data2) => {
                if (err) return console.log(err.message);

                for (let obj of data) {
                  let foundedIndex = _.findIndex(data2, {
                    day: obj.day,
                    page: obj.page,
                  });
                  if (foundedIndex != -1) {
                    obj.count = obj.count + data2[foundedIndex].count;
                  }
                }

                data = data.concat(data2);

                this.stats.messagesCountObject = data;
                this.renderLineChart(data);
                this.stats.messagesCount = _.chain(data)
                  .map("count")
                  .sum()
                  .value();

                this.getCountByPagesAndPlatforms();
                this.getConversationCount();

                console.log("Yes, Optimized");

                this.loading = false;
              }
            );
          } else {
            console.log("Not Optimized");
            this.stats.messagesCountObject = data;
            this.renderLineChart(data);
            this.stats.messagesCount = _.chain(data).map("count").sum().value();

            this.getCountByPagesAndPlatforms();
            this.getConversationCount();

            this.loading = false;
          }
        }
      );
    },
    getDmCmntAds() {
      //DM
      //HEAD /api/v1/conversations?after=1648771200000&before=16520544000005&notTagId=5e88b874817d3903cbe7754c&tagId=5eb7304806846b3b928e05d9&workspaceId=623c88a9b1b4a14491a18c00

      //CMNT COUNT
      //HEAD /api/v1/conversations?after=1648771200000&before=1652054400000&notTagId=5e88b874817d3903cbe7754c&notTagId=5eb7304806846b3b928e05d9&workspaceId=623c88a9b1b4a14491a18c00tagId=5eb7304806846b3b928e05d9&workspaceId=623c88a9b1b4a14491a18c00

      //AD CONVERSATİONS
      //HEAD /api/v1/conversations?after=1648771200000&before=1652054400000&notTagId=5e88b874817d3903cbe7754c&tagId=5eb72e1906846b3b928d80e4&workspaceId=623c88a9b1b4a14491a18c00

      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
        },
      };
      if (this.getInboxFilters.after)
        payload.query.after = this.getInboxFilters.after;
      if (this.getInboxFilters.before)
        payload.query.before = this.getInboxFilters.before;
      if (this.getInboxFilters.pageIds)
        payload.query.pageId = this.getInboxFilters.pageIds;

      //payload.query.notTagId = "5e88b874817d3903cbe7754c";
      payload.query.tagId = "5eb7304806846b3b928e05d9";

      _system.services.statistics.getDirectMessageCount(
        payload,
        (err, data) => {
          if (err) return console.log(err.message);

      //    console.log("only Direct Messages", data.headers["x-total-count"]);
          var onlyDmCount = data.headers["x-total-count"];

          payload = {
            query: {
              workspaceId: this.currentWorkspace._id,
            },
          };
          if (this.getInboxFilters.after)
            payload.query.after = this.getInboxFilters.after;
          if (this.getInboxFilters.before)
            payload.query.before = this.getInboxFilters.before;
          if (this.getInboxFilters.pageIds)
            payload.query.pageId = this.getInboxFilters.pageIds;
           
          //payload.query.notTagId = "5e88b874817d3903cbe7754c";
          payload.query.tagId = "5eb72e1906846b3b928d80e4";

          _system.services.statistics.getAdConversationCount(
            payload,
            (err, data) => {
              if (err) return console.log(err.message);

          //    console.log("only Ads comments", data.headers["x-total-count"]);
              var onlyAdsCount = data.headers["x-total-count"];

              payload = {
                query: {
                  workspaceId: this.currentWorkspace._id,
                },
              };
              if (this.getInboxFilters.after)
                payload.query.after = this.getInboxFilters.after;
              if (this.getInboxFilters.before)
                payload.query.before = this.getInboxFilters.before;
              if (this.getInboxFilters.pageIds)
                payload.query.pageId = this.getInboxFilters.pageIds;

              payload.query.notTagId = "5eb7304806846b3b928e05d9"; //DM ID

              _system.services.statistics.getCommentCount(
                payload,
                (err, data) => {
                  if (err) return console.log(err.message);

               //   console.log("only comments", data.headers["x-total-count"]);
                  var onlyCmntCount = data.headers["x-total-count"];

                  this.renderByDirectMessagesComments(
                    onlyDmCount,
                    onlyCmntCount,
                    onlyAdsCount
                  );
                }
              );
            }
          );
        }
      );
      payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
        },
      };
      if (this.getInboxFilters.after)
        payload.query.after = this.getInboxFilters.after;
      if (this.getInboxFilters.before)
        payload.query.before = this.getInboxFilters.before;
      if (this.getInboxFilters.pageIds)
        payload.query.pageId = this.getInboxFilters.pageIds;

      payload.query.tagId = "5d08faef894b33a71395ce93";
      payload.query.notTagId = "5e88b874817d3903cbe7754c";

      _system.services.statistics.getPositiveMessageCount(
        payload,
        (err, data) => {
          if (err) return console.log(err.message);

        //  console.log("only Positive", data.headers["x-total-count"]);
          var onlyPositiveCount = data.headers["x-total-count"];

          payload = {
            query: {
              workspaceId: this.currentWorkspace._id,
            },
          };
          if (this.getInboxFilters.after)
            payload.query.after = this.getInboxFilters.after;
          if (this.getInboxFilters.before)
            payload.query.before = this.getInboxFilters.before;
          if (this.getInboxFilters.pageIds)
            payload.query.pageId = this.getInboxFilters.pageIds;

          payload.query.tagId = "5ce3b809e4e4974e9119c373";
          payload.query.notTagId = "5e88b874817d3903cbe7754c";

          _system.services.statistics.getNegativeMessageCount(
            payload,
            (err, data) => {
              if (err) return console.log(err.message);

         //     console.log("only Negative", data.headers["x-total-count"]);
              var onlyNegativeCount = data.headers["x-total-count"];

              payload = {
                query: {
                  workspaceId: this.currentWorkspace._id,
                },
              };
              if (this.getInboxFilters.after)
                payload.query.after = this.getInboxFilters.after;
              if (this.getInboxFilters.before)
                payload.query.before = this.getInboxFilters.before;
              if (this.getInboxFilters.pageIds)
                payload.query.pageId = this.getInboxFilters.pageIds;

              payload.query.tagId = "5c9249bf52e76e43af65ec05";
              payload.query.notTagId = "5e88b874817d3903cbe7754c";

              _system.services.statistics.getNeutralMessageCount(
                payload,
                (err, data) => {
                  if (err) return console.log(err.message);

                 // console.log("only Neutral", data.headers["x-total-count"]);
                  var onlyNeutralCount = data.headers["x-total-count"];

                  this.renderByTaggedComments(
                    onlyPositiveCount,
                    onlyNegativeCount,
                    onlyNeutralCount
                  );
                }
              );
            }
          );
        }
      );
    },
    getConversationCount() {
      /*       let payload = {
        query:{
          workspaceId: this.currentWorkspace._id
        }
      }
      if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after;
      if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before;
      if(this.getInboxFilters.pageIds) payload.query.pageId = this.getInboxFilters.pageIds;

      _system.services.statistics.getConversationCount(payload, (err, data) => {
              if(err) return alert(err.message); */

      //console.log(data.headers['x-total-count']);
      //this.stats.conversationCount = data.headers['x-total-count']
      this.stats.conversationCount = _.chain(this)
        .get("stats.messagesCountObject")
        .defaultTo([])
        .map("count")
        .sum()
        .value();
      /*  this.stats.messagesCountObject = data
              this.stats.messagesCount = _.chain(data).map('count').sum().value();
 */
      //});
    },
    getTagsWithCounts() {
      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
        },
      };
      if (this.getInboxFilters.after)
        payload.query.after = this.getInboxFilters.after;
      if (this.getInboxFilters.before)
        payload.query.before = this.getInboxFilters.before;
      if (this.getInboxFilters.pageIds)
        payload.query.pageId = this.getInboxFilters.pageIds;

      _system.services.statistics.getTagsCount(payload, (err, data) => {
        if (err) return console.log(err.message);

        this.stats.tags = _.map(data, (tag) => {
          if (_.find(this.currentWorkspace.userTags, { _id: tag.tagId })) {
            tag.color = _.find(this.currentWorkspace.userTags, {
              _id: tag.tagId,
            }).color;
            return tag;
          } else {
            tag.color = "#d5d5d5";
            return tag;
          }
        });

        //this.stats.tags



/*         let messageCounts = {
          dms:0,
          comments:0,
          adsComments:0
        }

        for (const tag of this.stats.tags) {

          if(tag.tagName == 'Direct Message'){
            messageCounts.dms += tag.count;
          }

          if(tag.tagName == 'Ads Comments'){
            messageCounts.dms += tag.count;
          }

        } */

        //Result

        this.renderTagsByChannels();


        //this.renderByDirectMessagesComments(messageCounts.dms, messageCounts.comments, messageCounts.adsComments);

        //console.log('tags',this.stats.tags);
      });
    },
    getAverageResponseTime() {
      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
        },
      };
      if (this.getInboxFilters.after)
        payload.query.after = this.getInboxFilters.after;
      if (this.getInboxFilters.before)
        payload.query.before = this.getInboxFilters.before;
      if (this.getInboxFilters.pageIds)
        payload.query.pageId = this.getInboxFilters.pageIds;

      _system.services.statistics.getAverageResponseTime(
        payload,
        (err, data) => {
          if (err) return console.log(err.message);

          this.stats.averageResponseTime = data;
        }
      );
    },
    getCountByPagesAndPlatforms() {
      /*       let payload = {
        query:{
          workspaceId: this.currentWorkspace._id
        }
      }
      if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after;
      if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before;
      if(this.getInboxFilters.pageIds) payload.query.pageId = this.getInboxFilters.pageIds;

      _system.services.statistics.getCountByPagesAndPlatforms(payload, (err, data) => {
              if(err) return alert(err.message); */

      this.stats.getCountByPagesAndPlatforms = _.chain(this)
        .get("stats.messagesCountObject")
        .defaultTo([])
        .groupBy("platform")
        .map((value, key) => ({
          platform: key,
          count: _.chain(value).map("count").sum().value(),
        }))
        .value();
      this.renderByPlatforms();
      //this.renderByDirectMessagesComments();

      //});
    },
    getAudincesByPages() {
      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
        },
      };
      if (this.getInboxFilters.after)
        payload.query.after = this.getInboxFilters.after;
      if (this.getInboxFilters.before)
        payload.query.before = this.getInboxFilters.before;
      if (this.getInboxFilters.pageIds)
        payload.query.pageId = this.getInboxFilters.pageIds;

      _system.services.statistics.getAudincesByPages(payload, (err, data) => {
        if (err) return console.log(err.message);

        this.stats.getAudincesByPages = data;
        this.renderAudience();
      });
    },
    getAvgFirstResponseTime() {
      /*       const div = this.stats.averageResponseTime.repliedConversationCount
      return  moment.utc(_.chain(this.stats.averageResponseTime.averageFirstReplyTime).divide(div == 0 ? 1 : div).value()).format('HH:mm:ss') */
      const time = moment.duration(
        this.stats.averageResponseTime.averageFirstReplyTime
      );
      var hours = Math.floor(time.asHours());
      var mins = Math.floor(time.asMinutes()) - hours * 60;

      return hours + "h " + mins + "m";
      //return moment.utc(this.stats.averageResponseTime.averageFirstReplyTime).format('HH[h] mm[m]');
    },
    getTotalConversation() {
      return _.chain(this.getStatistics)
        .filter()
        .map((s) => _.get(s, "conversationCount", 0))
        .sum()
        .value();
    },
    getTotalTickets() {
      let test = _.chain(this.stats.tags)
        .filter({ tagId: this.getEnumaratedTags.Ticket._id })
        .map((s) => _.get(s, "count", 0))
        .sum()
        .value();

      return test;
    },
    getTotalResolvedTickets() {
      let test = _.chain(this.stats.tags)
        .filter({ tagId: this.getEnumaratedTags.TicketSolved._id })
        .map((s) => _.get(s, "count", 0))
        .sum()
        .value();
      return test;
    },
      renderLineChart(datum) {
   //   console.log("willbe rendered into line chart", datum);
      let lineIndex = 0;
      const dates = _.chain(datum)
        .groupBy((statistic) => statistic.page.toString())
        .values()
        .first()
        .sortBy(["createdAt"])
        .map((statistic) => moment(statistic.createdAt).utc().format("D MMM"))
        .value();

      const series = _.chain(datum)
        .groupBy((statistic) => statistic.page.toString())
        .map((value, key) => {
          const statistic = _.chain(value)
            .sortBy(["createdAt"])
            .map("count")
            .value();
          const page =
            this.accountsById[_.chain(value).first().get("page").value()];
          /*           console.log('id', _.chain(value).first().get('page').value())
          console.log('founed', page) */
          if (page) {
            let color;
            if (lineIndex < this.customColorPalette.length) {
               // use color palette if lines are not bigger than palette length 
              color = this.customColorPalette[lineIndex++]; 
            } else {
              //else Generate a random color
              color = `hsl(${Math.random() * 360}, ${Math.random() * 50 + 50}%, ${Math.random() * 20 + 40}%)`;
            }

            this.lineChartConfig.push({
              name: page.name,
              platform: page.platform,
              color: color,
              id: page.id
            })

            const serie = {
              name: page.name + "*" + JSON.stringify(page),
              type: "line",
              xAxisIndex: 0,
              connectNulls: true,
              smooth: true,
              symbolSize: 8,
              itemStyle: {
                borderWidth: 4,
                color: color/* "hsl(" + Math.random() * 600 + ", 55%, 69% )" */,
              },
              lineStyle: {
                width: 4, 
              },
              areaStyle: {
                opacity: 0.1,
              },
              data: statistic,
            };
            return serie;
          }
        })
        .value();

      let option = {
        //color: colors,
        grid: {
          left: "5%",
          top: 40,
          right: "4%",
          bottom: 40,
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,0.6)",
          borderColor: "#ddd",
          borderWidth: 0,
          padding: 10,
          extraCssText: "box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.05);",
          formatter: (params) => {
            var colorSpan = (color) =>
              '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
              color +
              '"></span>';
            let rez = "<p>" + params[0].axisValue + "</p>";
            //console.log(params); //quite useful for debug
            var pageObj = "";
            params.forEach((item) => {
              //console.log(item); //quite useful for debug
              pageObj = JSON.parse(item.seriesName.split("*")[1]);
              var xx =
                '<p style="margin:2px;"> <img class="ui avatar image" src="' +
                this.getPlatformImage(pageObj.platform, null) +
                '"> <img style="width: 26px; height: 26px; display: inline-block; border: 3px solid ' +
                item.color +
                ';" class="ui avatar image" src="' +
                pageObj.avatar +
                '" alt="">' +
                pageObj.name +
                ': <b style="font-size: 18px;">' +
                item.data +
                "</b> </p>";
              rez += xx;
            });

            return rez;
          },
          textStyle: {
            color: "#333333",
          },
          axisPointer: {
            type: "line",
            lineStyle: {
              type: "dashed",
              color: "#ccc",
            },
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisTick: {
              alignWithLabel: true,
            },
            data: dates,
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
          },
        ],
        series: series,
      };

      this.lineChart.setOption(option, true);
    },
    renderByRatings() {
      let byRatingsElement = window.echarts.init(
        document.getElementById("byRatings")
      );

      let ratingsData = [
        {
          name: "Twitter",
          value: 586,
          itemStyle: {
            color: "#78CBEF",
          },
        },
        {
          name: "Google My Business",
          value: 91,
          itemStyle: {},
        },
        {
          name: "Facebook",
          value: 4716,
          itemStyle: {
            color: "#547BBC",
          },
        },
        {
          name: "Instagram",
          value: 790,
          itemStyle: {
            color: "#A34488",
          },
        },
        {
          name: "App Store",
          value: 3,
          itemStyle: {},
        },
      ];

      let optionRatings = {
        grid: {
          left: "0%",
          top: "0%",
          right: "0%",
          bottom: "0%",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "Received Messages",
            type: "pie",
            radius: "55%",
            data: ratingsData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      byRatingsElement.setOption(optionRatings);
    },
    renderByPlatforms() {
      var byPlatfroms = window.echarts.init(
        document.getElementById("byPlatform")
      );

      let byPlatform = _.chain(this.stats.getCountByPagesAndPlatforms)
        .groupBy("platform")
        .map((values, platformId) => ({
          name: this.networksById[platformId].name,
          value: _.chain(values)
            .map((v) => _.get(v, "count", 0))
            .sum()
            .value(),
          itemStyle: {
            color: (() => {
              if (this.networksById[platformId].name == "Facebook")
                return "#547BBC";
              if (this.networksById[platformId].name == "Instagram")
                return "#A34488";
              if (this.networksById[platformId].name == "Twitter")
                return "#78CBEF";
              if (this.networksById[platformId].name == "Youtube")
                return "#E9644A";
              if (this.networksById[platformId].name == "Email")
                return "#222222";
              if (this.networksById[platformId].name == "Phone")
                return "#8EF2B6";
            })(platformId),
          },
        }))
        .value();

    //  console.log("sanirim   :  ", byPlatform);

      let optionPlatform = {
        grid: {
          left: "0%",
          top: "0%",
          right: "0%",
          bottom: "0%",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        label: {
          show: true,
          formatter: "{b}: {c}\n ({d}%)",
          fontSize: 10,
        },
        series: [
          {
            name: "Received Messages",
            type: "pie",
            radius: "55%",
            data: byPlatform,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      byPlatfroms.setOption(optionPlatform);
    },
    renderByDirectMessagesComments(dmCount, cmntCount, adsCount) {
      var byDmCmntElement = window.echarts.init(
        document.getElementById("byDmCmnt")
      );

      //console.log('inRenderDmCount ', dmCount)
      //console.log('inRenderCmntCount ', cmntCount)

      /*   let byDmCmnt = _.chain(this.stats.getCountByPagesAndPlatforms).groupBy('platform').map((values, platformId) => ({
     name: this.networksById[platformId].name, 
     value: _.chain(values).map(v => _.get(v, 'count', 0)).sum().value(),
      itemStyle: {
                color: (() => {
                  
                  if(this.networksById[platformId].name == 'Facebook') return '#547BBC'
                  if(this.networksById[platformId].name == 'Instagram') return '#A34488'
                  if(this.networksById[platformId].name == 'Twitter') return '#78CBEF'
                  if(this.networksById[platformId].name == 'Youtube') return '#E9644A'
                  if(this.networksById[platformId].name == 'Email') return '#222222'
                  if(this.networksById[platformId].name == 'Phone') return '#8EF2B6'
                })(platformId)
              }
     
     })).value() */

      let byDmCmnt = [
        {
          name: "Direct Messages",
          value: dmCount,
        },
        {
          name: "Comments",
          value: cmntCount,
        },
        {
          name: "Ads Comments",
          value: adsCount,
        },
      ];

     // console.log("Example of pie chart Data", byDmCmnt);

      let optionPlatform = {
        grid: {
          left: "0%",
          top: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        label: {
          show: true,
          formatter: "{b}: \n {c} ({d}%)",
          fontSize: 10,
        },
        series: [
          {
            name: "Received Messages",
            type: "pie",
            radius: "55%",
            data: byDmCmnt,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      byDmCmntElement.setOption(optionPlatform);
    }, /// Positive Negative Neutral Tag Chart
    renderByTaggedComments(positiveCount, negativeCount, neutralCount) {
      var byTaggedElement = window.echarts.init(
        document.getElementById("byTagCmnt")
      );

      let byTaggedCmnt = [
        {
          name: "Positive",
          value: positiveCount,
        },
        {
          name: "Negative",
          value: negativeCount,
        },
        {
          name: "Neutral",
          value: neutralCount,
        },
      ];

     // console.log("Example of pie chart Data", byTaggedCmnt);

      let optionPlatform = {
        grid: {
          left: "0%",
          top: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        label: {
          show: true,
          formatter: "{b}: {c}\n ({d}%)",
          fontSize: 10,
        },
        series: [
          {
            name: "Received Messages",
            type: "pie",
            radius: "55%",
            data: byTaggedCmnt,
            color: ['#4dd275', '#ff0000', '#bbbbbb'],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      byTaggedElement.setOption(optionPlatform);
    },
    renderTagsByChannels() {
      const messageTags = this.stats.tags;

   //   console.log("messageTags ,", messageTags);

      this.tags = _.chain(messageTags)
        .groupBy((tag) => tag.page.toString())
        .map((tags2, pageId) => {
          const tags = _.chain(tags2)
            .filter((t) => t.page.toString() == pageId.toString())
            .groupBy((t) => t.tagId)
            .map((tags, tagId) => ({
              color: _.first(tags).color,
              tagId: _.first(tags).tagId,
              name: _.first(tags).tagName,
              total: _.chain(tags).map("count").sum().value(),
            }))
            .sortBy((t) => t.total)
            .reverse()
            .value();
          return { tags, pageId };
        })
        .value();
    },
    renderAudience() {
      this.audience = this.stats.getAudincesByPages;
    },
    renderTeamStatistics() {
      //const results = _.chain(workspaceUsers).map(workspaceUser => Axios.get('/api/v1/...') ).thru( promises => Promise.all(promises) ).value()
      this.teamStatistics = [];
      console.log("teamrendered", this.teamStatistics);
      console.log("ws", this.workspaceusers.length);

      _.each(this.workspaceusers, (workspaceUser) => {
        let payload = {
          query: {
            workspaceId: this.currentWorkspace._id,
          },
          params: {
            workspaceUserId: workspaceUser._id,
          },
        };

        if (this.getInboxFilters.after)
          payload.query.after = this.getInboxFilters.after;


        if (this.getInboxFilters.before)
          payload.query.before = this.getInboxFilters.before;

        //if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before

        if (this.getInboxFilters.pageIds)
          payload.query.pageId = this.getInboxFilters.pageIds;

        _system.services.statistics.getUserStatisticsByWorkspaceUserId(
          payload,
          (err, data) => {
            if (err)
              alert(
                "New reports are getting ready. Could you please visit again in 30 seconds?"
              );

            if (data.averageFirstReplyTime) {
              const time = moment.duration(data.averageFirstReplyTime);
              var hours = Math.floor(time.asHours());
              var mins = Math.floor(time.asMinutes()) - hours * 60;
              //data.averageFirstReplyTime = moment.utc(data.averageFirstReplyTime*1000).format('HH[h] mm[m]');
              data.averageFirstReplyTime = hours + "h " + mins + "m";
            }

            this.teamStatistics.push(data);

            this.totalRepliedMesages = _.sumBy(
              this.teamStatistics,
              "repliedCount"
            );
          }
        );
      });

      /*     _system.services.statistics.getUserStatistics(payload,(err, data) => { 
      if(err) return alert(err.message);

     this.teamStatistics = _.chain(data).groupBy(s => s.user._id.toString()).values().map(s => ({ 
                              user: s[0].user, 
                              conversationCount: _.chain(s).map(f => _.get(f, 'conversationCount', 0)).sum().value(), 
                              repliedCount: _.chain(s).map(f => _.get(f, 'repliedCount', 0)).sum().value(), 
                              averageFirstReplyTime: _.chain(s).map(f => _.get(f, 'averageFirstReplyTime', 1) * _.get(f, 'repliedCount', 0) ).map(_.toNumber).sum().divide( _.chain(s).map('repliedCount').filter().map(_.toNumber).sum().value() ).value()
                              })).map(s => _.set(s, 'averageFirstReplyTime', _.isNaN(s.averageFirstReplyTime) ? '-' : moment.utc(s.averageFirstReplyTime).format('HH:mm:ss'))).value()

     }); */
    },
    exportToPDF() {
      let body = document.body
      let html = document.documentElement
      let height = Math.max(body.scrollHeight, body.offsetHeight,
                       html.clientHeight, html.scrollHeight, html.offsetHeight)
      let element = document.getElementById("wrapper")
      let heightCM = height / 35.35
      html2pdf(element, {
        margin: 0,
        filename: 'Statistics.pdf',
        html2canvas: { scale: 4, letterRendering: true, dpi: 192, useCORS: true },
        jsPDF: {
            orientation: 'portrait',
            unit: 'cm',
            format: [heightCM, 30]
          }
      })
    },
    getColor(accountsById) {
      const matchingObject = this.lineChartConfig.find(item => {
        return(
           accountsById.platform === item.platform &&
           accountsById.name === item.name &&
           accountsById.id === item.id
        );
      });
      return matchingObject ? matchingObject.color : 'none';
    }
  },
  mounted() {
    $(".ui.dropdown").dropdown({
      action: "nothing",
      on: "hover",
      transition: "scale",
    });

    let currentSec = +new Date();
    let currentSecMinus30Days = currentSec - 2592000000;
    let currentSecMinus10Days = currentSec - 2592000000 / 3;

    /*     this.setInboxFiltersAfter(currentSecMinus10Days)
    this.setInboxFiltersBefore(currentSec + 86400000) */

    this.lineChart = window.echarts.init(document.getElementById("main"));

    this.renderLineChart();
    this.renderTagsByChannels();
    this.renderTeamStatistics();
    this.renderByPlatforms();

    this.renderByRatings();

    //this.renderByDirectMessagesComments();
    this.setLoadingStatistics(false);

    var bySentiment = window.echarts.init(document.getElementById("sentiment"));

    let optionSentiment = {
      grid: {
        left: "0%",
        top: "0%",
        right: "0%",
        bottom: "0%",
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
      series: [
        {
          name: "Received Messages",
          type: "pie",
          radius: "55%",
          data: [
            {
              name: "Positive",
              itemStyle: {
                color: "#62d68e",
              },
              value: Math.round(Math.random() * 100000),
            },
            {
              name: "Negative",
              itemStyle: {
                color: "#D76662",
              },
              value: Math.round(Math.random() * 100000),
            },
            {
              name: "Neutral",
              itemStyle: {
                color: "#bbb",
              },
              value: Math.round(Math.random() * 100000),
            },
          ],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };

    bySentiment.setOption(optionSentiment);

    var byTopTags = window.echarts.init(document.getElementById("topTags"));
    let optionTopTags = {
      dataset: [
        {
          dimensions: ["name", "age", "profession", "score", "date"],
          source: [
            ["Hannah Krause", 41, "Engineer", 314, "2011-02-12"],
            ["Zhao Qian", 20, "Teacher", 351, "2011-03-01"],
            ["Jasmin Krause ", 52, "Musician", 287, "2011-02-14"],
            ["Li Lei", 37, "Teacher", 219, "2011-02-18"],
            ["Karle Neumann", 25, "Engineer", 253, "2011-04-02"],
            ["Adrian Groß", 19, "Teacher", "-", "2011-01-16"],
            ["Mia Neumann", 71, "Engineer", 165, "2011-03-19"],
            ["Böhm Fuchs", 36, "Musician", 318, "2011-02-24"],
            ["Han Meimei", 67, "Engineer", 366, "2011-03-12"],
          ],
        },
        {
          transform: {
            type: "sort",
            config: { dimension: "score", order: "desc" },
          },
        },
      ],
      xAxis: {
        type: "category",
        axisLabel: { interval: 0, rotate: 30 },
      },
      yAxis: {},
      series: {
        type: "bar",
        encode: { x: "name", y: "score" },
        datasetIndex: 1,
      },
    };

    byTopTags.setOption(optionTopTags);
  },
  created() {

    let currentSec = +new Date();
    let currentSecMinus30Days = currentSec - 2592000000;
    let currentSecMinus7Days = currentSec - 2592000000 / 3;
    //let currentSecMinus10Days = currentSec - 2592000000/3;
    let currentSecMinus10Days = currentSec - 1000 * 60 * 60 * 24 * 1;

    //Set high volume customers here
    if (this.getUser.email.includes("humanforest")) {
      currentSecMinus10Days = currentSec - 1000 * 60 * 60 * 24 * 5;
    }

    this.startDate = new Date(currentSecMinus10Days).toISOString();
    this.endDate = new Date(currentSec + 86400000).toISOString();

    this.currentDate = new Date(currentSec + 86400000).toISOString();

    this.setInboxFiltersAfter(currentSecMinus10Days);
    this.setInboxFiltersBefore(currentSec + 86400000);

    this.picker.dateRange.startDate = currentSecMinus10Days;
    this.picker.dateRange.endDate = currentSec + 86400000;

    //this.getConversationCount();
    if (!window.location.href.includes("test=getCountByPages")) {
   //   console.log("LOADED: Message Count");
      this.getMessageCounts();
    }

    this.getTagsWithCounts();
    this.getAverageResponseTime();
    //this.getCountByPagesAndPlatforms();
    this.getAudincesByPages();

    this.getDmCmntAds();

    //this.setLoadingStatistics(true);
  },
  beforeDestroy() {
    console.log("Stop");
    return;
  },
};
</script>

<template>
  <div
    style="padding: 0"
    class="ui basic segment"
  >
  <!-- :class="loading && 'loading'" -->
<div v-if="isAccountsPlatformShopifExists" class="ui grid">
  <iframe :src=" $custom.config.iframe.url + '/login?token=' + getJwt + '&redirect=report'" style="width: 100%; padding: 0; margin:0; height: 100vh; min-height: 100vh;" frameborder="0"></iframe>
</div>

<div v-if="!isAccountsPlatformShopifExists" id="wrapper" class="ui stackable grid">

  <div style="background: #f2f2f2" class="row">
    <div style="background: #f2f2f2" class="eight wide column">
      <div class="ui dropdown labeled icon button">
        <i class="filter icon"></i>
        <span>Filter Channels</span>
        <div class="menu">
          <div class="divider"></div>
          <div class="header">
            <i class="th list icon"></i>
            Channels
          </div>
          <div class="scrolling menu">
            <div
              v-for="account in orderByName(onlyActiveAccounts)"
              :key="account._id"
              @click="updateAccounts(account)"
              style="display: flex; margin: 0; line-height: 1.4em"
              class="item checkboxInput"
            >
              <div
                :class="isActive(account._id, 'Channels') ? 'checked' : ''"
                class="checkbox"
              >
                <i class="icon-check check icon"></i>
              </div>
              <div style="position: relative" class="checkboxLabel">
                <img
                :style="{
                    border: '3px solid ' + getColor(account),
                    marginRight: '4px',
                    width: '22px',
                    borderRadius: '5px',
                    verticalAlign: 'middle'
                  }"
                  :src="account.avatar"
                />
                <img
                  :src="getPlatformImage(account.platform)"
                  style="
                    bottom: -5.5px;
                    width: 14px;
                    height: 14px;
                    border-radius: 20px;
                    vertical-align: middle;
                    position: absolute;
                    left: -5.5px;
                    border: 1px solid #fff;
                  "
                  alt=""
                />
                <span style="display: inline-block">{{
                  account.name
                }}</span>
              </div>
            </div>
          </div>
          <div class="footer">
            <div style="background: #f5f5f5" class="item">
              <div @click="applyFilter()" class="ui fluid blue button">
                Apply filter
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="ui teal button float left" @click="exportToPDF">
        Export to PDF
      </button>
    </div>
    <div
      style="background: #f2f2f2; text-align: right"
      class="eight wide column"
    >
      <date-range-picker
        :opens="'left'"
        :ranges="{
          'Last 24 Hours': [
            new Date(+new Date() - 1000 * 60 * 60 * 24 * 1),
            new Date(),
          ],
          'Last 7 Days': [
            new Date(+new Date() - 1000 * 60 * 60 * 24 * 7),
            new Date(),
          ],
          'Last 10 Days': [
            new Date(+new Date() - 1000 * 60 * 60 * 24 * 10),
            new Date(),
          ],
          'Last 30 Days': [
            new Date(+new Date() - 1000 * 60 * 60 * 24 * 30),
            new Date(),
          ],
          'Last 90 Days': [
            new Date(+new Date() - 1000 * 60 * 60 * 24 * 90),
            new Date(),
          ],
        }"
        @finish-selection="dateSelected2($event)"
        @start-selection="dateSelected($event)"
        :minDate="picker.minDate"
        :maxDate="picker.maxDate"
        v-model="picker.dateRange"
        @update="updateTime2"
      ></date-range-picker>

      <!--   <div style="position: relative; display: inline-block; vertical-align: top;">
<span class="fromTo">FROM :</span>
<datetime style="position:relative;display: inline-block;" :max-datetime="currentDate" v-model="startDate" input-id="startDate">
    <template slot="button-confirm" slot-scope="scope" >
                <span style="display: block; padding: 5px 10px; background: #f1f1f1;" @click="updateTime()">Update</span>
    </template>
</datetime>
</div>
<div style="position: relative; display: inline-block; vertical-align: top;">
    <span class="fromTo">TO :</span><datetime style="position:relative; display: inline-block;" :min-datetime="startDate" :max-datetime="currentDate" v-model="endDate"  input-id="endDate">
      <template slot="button-confirm" slot-scope="scope" >
                  <span style="display: block; padding: 5px 10px; background: #f1f1f1;" @click="updateTime()">Update</span>
      </template>
  </datetime>
</div> -->
    </div>
  </div>

  <div style="background: #f9f9f9" class="sixteen wide column">
    <!--         <div v-if="loadingStatistics" style="height:100%; overflow: hidden;" class="ui grid centered stackable">
        <div class="six wide computer sixteen wide mobile column">
            <div class="ui basic segment center aligned">
            <div style="padding:0; color: #333;" class="ui basic segment">
            </div>
            <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
            <br>
                            Reports are getting ready...
            </div>
        </div>
    </div> -->

    <div style="padding: 0" class="ui basic segment">
      <div class="ui stackable equal width grid">
        <div v-if="getUser.email.includes('@juphy')" class="column">
          <div style="height: 100%;" class="reportCard mediumBlueLish">
            <div style="display: inline-block">
              <span style="font-size: 30px">{{
                stats.conversationCount
              }}</span>
              <p style="position:absolute">Conversations by Chatbot</p>
            </div>
            <i style="float: right" class="comments large icon"></i>
          </div>
        </div>
        <div v-if="getUser.email.includes('@juphy')" class="column">
          <div class="reportCard darkGreenLish">
            <div style="display: inline-block">
              <span style="font-size: 30px">{{
                stats.conversationCount
              }}</span>
              <p>Sales by Chatbot</p>
            </div>
            <i style="float: right" class="dollar large icon"></i>
          </div>
        </div>
        <div class="column">
          <div class="reportCard blueLish">
            <div style="display: inline-block">
              <span style="font-size: 30px">{{
                stats.conversationCount
              }}</span>
              <p>Total Conversations</p>
            </div>
            <i style="float: right" class="comments large icon"></i>
          </div>
        </div>
        <div class="column">
          <div class="reportCard gecLish">
            <div style="display: inline-block">
              <span style="font-size: 30px">{{ totalRepliedMesages }}</span>
              <p>Replied</p>
            </div>
            <i style="float: right" class="Reply large icon"></i>
          </div>
        </div>
        <div class="column">
          <div style="height: 100%;" class="reportCard purpLish">
            <div style="display: inline-block">
              <span style="font-size: 30px">{{
                getAvgFirstResponseTime()
              }}</span>
              <p style="position: absolute;">Average Response Time</p>
            </div>
            <i style="float: right" class="clock large icon"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="ui stackable grid">
      <div style="padding: 0" class="row">
        <div class="sixteen wide column">
          <div class="ui basic segment" :class="loading && 'loading'">
            <h5 style="color: rgba(2, 2, 2, 0.6)" class="ui header">
              Total Conversations
            </h5>
            <div
              id="main"
              style="width: 100%; height: 350px; padding: 0"
            ></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="ten wide column">
          <div
            style="overflow: auto; max-height: 500px"
            class="ui segment delight"
          >
            <table v-if="tags.length" class="ui very basic celled table">
              <thead>
                <tr>
                  <th>Channels</th>
                  <th>Tags</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tag in tags" :key="tag.pageId">
                  <td style="min-width: 150px; vertical-align: top">
                    <img
                      class="ui avatar image"
                      :src="
                        getPlatformImage(
                          accountsById[tag.pageId].platform,
                          null
                        )
                      "
                      alt=""
                    />
                    <img
                      class="ui avatar image"
                      :src="accountsById[tag.pageId].avatar"
                      alt=""
                      :style="{ border: '3px solid ' + getColor(accountsById[tag.pageId]) }"
                    />
                    {{ accountsById[tag.pageId].name.substring(0, 14) }}
                  </td>
                  <td>
                    <div
                      v-if="ratingDistribution(tag.tags).length"
                      style="
                        display: block;
                        padding-bottom: 1rem;
                        margin-bottom: 1rem;
                        border-bottom: 1px solid #f1f1f1;
                      "
                    >
                      <h5>Ratings distribution</h5>
                      <div
                        v-if="ratingDistribution(tag.tags).length"
                        style="
                          display: flex;
                          width: 80%;
                          border-radius: 1rem;
                        "
                      >
                        <div
                          v-for="tpie in ratingDistribution(tag.tags)"
                          :key="tpie.total"
                          :style="
                            'text-align: right; padding: 5px 10px; min-width: 4rem; width: ' +
                            tpie.percentage +
                            '%; height: 2rem; border-radius: ' +
                            tpie.radius +
                            ' background: ' +
                            tpie.color
                          "
                          :data-tooltip="
                            '#' +
                            tpie.total +
                            ' - ' +
                            tpie.name +
                            ' reviews'
                          "
                          data-inverted=""
                        >
                          <span
                            style="
                              font-weight: bold;
                              color: rgba(2, 2, 2, 0.55);
                            "
                          >
                            {{ tpie.percentage }}%
                          </span>
                        </div>
                      </div>
                    </div>

                    <a
                      v-for="t in tag.tags"
                      :key="t._id"
                      v-show="t.name"
                      style="margin-right: 5px; margin-bottom: 5px"
                      :style="{ background: t.color }"
                      class="ui small image label"
                    >
                      {{ t.name }}
                      <div style="float: right" class="detail">
                        {{ t.total }}
                      </div></a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="ui segment delight">
            <table class="ui very basic celled table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Replied Conversations</th>
                  <th>Assigned Conversations #</th>
                  <th>Avg. Response Time</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="teammember in teamStatistics"
                  :key="teammember._id"
                >
                  <td>{{ teammember.user.name }}</td>
                  <td>{{ teammember.repliedCount }}</td>
                  <td>{{ teammember.assignedConversationCount }}</td>
                  <td>
                    {{
                      teammember.averageFirstReplyTime
                        ? teammember.averageFirstReplyTime
                        : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="padding-left: 0" class="six wide column">
          <!--       <div class="ui segment delight">
  <h5 style="color: rgba(2,2,2,0.6);" class="ui header">Timing / Replies <a class="ui mini purple label"> <i class="lock icon"></i>Unlock</a></h5>
  <table style="opacity: 0.2;" class="ui very basic celled table">
    <tbody>
      <tr>
        <td> < 15 min </td>
        <td> 5% </td>
      </tr>
      <tr>
        <td> 15-30 min </td>
        <td> 25% </td>
      </tr>
      <tr>
        <td> 30 - 60 min </td>
        <td> 45% </td>
      </tr>
      <tr>
        <td> > 60 min </td>
        <td> 55% </td>
      </tr>
    </tbody>
  </table>
    </div> -->
          <div class="ui segment delight">
            <div class="ui stackable equal width grid">
              <div style="padding-right: 0.5rem" class="column">
                <div class="reportCard yellowLish">
                  <div style="display: inline-block">
                    <span style="font-size: 30px">{{
                      getTotalTickets()
                    }}</span>
                    <p>Tickets</p>
                  </div>
                  <i style="float: right" class="thumbtack large icon"></i>
                </div>
              </div>
              <div style="padding-left: 0.5rem" class="column">
                <div class="reportCard greenLish">
                  <div style="display: inline-block">
                    <span style="font-size: 30px">{{
                      getTotalResolvedTickets()
                    }}</span>
                    <p>Resolved</p>
                  </div>
                  <i style="float: right" class="check large icon"></i>
                </div>
              </div>
            </div>
            <div class="ui tiny message">
              <i class="icon info"></i> When you add <b>Ticket</b> or
              <b>Ticket Solved</b> tag into a conversation, this section
              will be updated accordingly.
            </div>
          </div>
          <!-- 
  <div class="ui segment delight">
    <h5 style="color: rgba(2,2,2,0.6);" class="ui header">Distribution By Ratings</h5>
      <div id="byRatings" style="width:100%; height: 250px; padding: 0;"></div>
  </div> -->

          <div class="ui segment delight">
            <h5 style="color: rgba(2, 2, 2, 0.6)" class="ui header">
              Distribution By Communication Platform
            </h5>
            <div
              id="byPlatform"
              style="width: 100%; height: 250px; padding: 0"
            ></div>
          </div>
          <div
            v-if="!getUser.email.includes('wise')"
            class="ui segment delight"
          >
            <h5 style="color: rgba(2, 2, 2, 0.6)" class="ui header">
              Distribution By Direct Messages, Comments on All Channels
            </h5>
            <div
              id="byDmCmnt"
              style="width: 100%; height: 250px; padding: 0"
            ></div>
          </div>

          <div
            v-if="getUser.email == 'alara@juphy.com'"
            class="ui segment delight"
          >
            <h5 style="color: rgba(2, 2, 2, 0.6)" class="ui header">
              Sentiment Analysis
              <a
                title="Juphy is using Google API for this solution so this solution requires additional cost, contact us to unlock"
                class="ui mini purple label"
              >
                <i class="lock icon"></i>Enterprise</a
              >
            </h5>
            <div
              id="sentiment"
              style="width: 100%; height: 250px; padding: 0"
            ></div>
          </div>
          <div
            v-if="!getUser.email.includes('wise')"
            class="ui segment delight"
          >
            <h5 style="color: rgba(2, 2, 2, 0.6)" class="ui header">
              Distribution By Sentiment Analysis
            </h5>
            <div
              id="byTagCmnt"
              style="width: 100%; height: 250px; padding: 0"
            ></div>
          </div>
          <!--          <div class="ui segment delight">
          <table class="ui very basic celled table">
                            <thead>
            <tr>
              <th>Audience</th>
              <th>Messages #</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(customer, i) in audience" :key="i">
                <td> 
                  <span v-if="customer.name">{{customer.name}}</span> 
                  <span v-if="customer.nick">{{customer.nick}}</span> 
                </td>
                <td> {{customer.count}} </td>
              </tr>
            </tbody>
          </table>
  </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- <StatisticsFilter></StatisticsFilter> -->
</div>


  </div>
</template>

<style scoped>
.zitem {
  padding: 0.7rem;
  margin: 0 !important;
  border-bottom: 1px solid #eee;
}

.fromTo {
  background: #ffffff;
  color: rgb(170, 170, 170);
  padding: 0 0 0 1em !important;
  height: 36px;
  border-radius: 5px 0 0 5px;
  z-index: 99999;
  display: inline-block;
  line-height: 32px;
  vertical-align: middle;
  border-left: 2px solid #e5e5e5 !important;
  border-top: 2px solid #e5e5e5 !important;
  border-bottom: 2px solid #e5e5e5 !important;
  border-right: 0px solid #e5e5e5 !important;
}

.fromTo:hover {
  cursor: none;
}

/deep/ .vdatetime-popup__actions__button {
  padding: 0px 0px !important;
}
/deep/ .vdatetime-input {
  vertical-align: middle;
  height: 36px;
  border-left: 0px solid #e5e5e5 !important;
  border-top: 2px solid #e5e5e5 !important;
  border-bottom: 2px solid #e5e5e5 !important;
  border-right: 2px solid #e5e5e5 !important;
  padding-left: 0.5rem !important;
  border-radius: 0 5px 5px 0 !important;
  color: #999999;
  max-width: 110px !important;
  line-height: 32px;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
}
/deep/ .vdatetime-input:hover {
  cursor: pointer;
  color: #444444;
}
.reportCard {
  padding: 1rem;
  border-radius: 5px;
  color: rgba(255, 255, 255, 0.9);
}

.yellowLish {
  background-image: radial-gradient(
    circle farthest-corner at 46.6% 51.1%,
    rgba(255, 146, 139, 1) 0%,
    rgba(255, 172, 129, 1) 90%
  );
}
.blueLish {
  background-image: radial-gradient(
    circle farthest-corner at 10% 20%,
    rgba(75, 108, 183, 1) 0%,
    rgba(55, 82, 141, 1) 90%
  );
}

.mediumBlueLish {
  background-image: radial-gradient(
    circle farthest-corner at 10% 20%,
    #5B8BBB 0%,
    #3A688F 90%
  );
}
.greenLish {
  background-image: radial-gradient(
    circle 1027px at -1.2% 102%,
    rgba(137, 228, 218, 1) 0%,
    rgba(240, 230, 142, 1) 90%
  );
}

.darkGreenLish {
  background-image: linear-gradient(
    45deg,
    #4CAF50 0%,
    #2E7D32 100%
  );
}

.geclish {
  background-image: radial-gradient(
    circle 1027px at -1.2% 102%,
    #37528d 0%,
    #a16eed 30%
  );
}
.purpLish {
  background-image: linear-gradient(
    109.6deg,
    rgba(119, 44, 232, 0.68) 11.5%,
    rgba(119, 44, 232, 1) 91.2%
  );
}
.orangeLish {
  background-image: radial-gradient(
    circle farthest-corner at 10% 20%,
    rgba(255, 122, 78, 1) 0%,
    rgba(255, 205, 112, 1) 90%
  );
}

.radioButtonGroup {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /* flex-direction: column; */
  -webkit-box-align: start;
  align-items: flex-start;
  flex-direction: column;
}

.radioButtonInput {
  margin: 0 0 10px;
  cursor: pointer;
}

.radioButtonGroup .radioButtonInput {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.radioButtonInput {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.radioButtonGroup .radioButtonInput .radioButton.selected {
  border: 2px solid #3960bd;
}

.radioButtonGroup .radioButtonInput .radioButton {
  position: relative;
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  cursor: pointer;
  border-radius: 18px;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.radioButtonGroup .radioButtonInput .radioButtonLabel {
  cursor: pointer;
  padding: 0 10px;
  font-size: 14px;
  line-height: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radioButtonGroup .radioButtonInput .radioButton.selected .selectedDot {
  background: #3960bd;
  opacity: 0.8;
}

.radioButtonGroup .radioButtonInput .radioButton .selectedDot {
  width: 7px;
  height: 7px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #aaa;
  opacity: 0;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  transform: translate(-50%, -50%);
  border-radius: 7px;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.radioButtonGroup .radioButtonInput:hover .radioButton.selected .selectedDot {
  opacity: 0.8;
}

.radioButtonGroup .radioButtonInput:hover .radioButton .selectedDot {
  opacity: 0.3;
}

.checkboxInput {
  margin: 0 0 10px;
  cursor: pointer;
}

.checkboxInput {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.checkboxInput .checkbox {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  min-width: 16px;
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 5px;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
  position: relative;
}

.checkboxInput .checkbox .icon-check {
  font-size: 10px;
  color: #aaa;
  opacity: 0;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
  -webkit-transform: translate(18%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  bottom: 25%;
  height: 12px;
  top: 25%;
}
.checkboxInput .checkboxLabel {
  margin: 0 10px;
  font-size: 14px;
  line-height: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 22px;
}

.checkboxInput:hover .checkbox .icon-check {
  opacity: 0.3;
}

.checkboxInput .checkbox.checked .icon-check {
  color: #3960bd;
  opacity: 1;
}

.checkboxInput .checkbox.checked {
  border-color: #3960bd;
}
</style>




// WEBPACK FOOTER //
// src/components/dashboard/Statistics.vue